import { createSlice } from '@reduxjs/toolkit'

export const CampaignStatusFilterSlice = createSlice({
  name: 'campaign_status_filter',
  initialState: {
    value: '',
  },
  reducers: {
    updateCampaignStatus: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateCampaignStatus } = CampaignStatusFilterSlice.actions

export default CampaignStatusFilterSlice.reducer